import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import "./academicCourses.css";
import { clearData } from '../../utils/localStorage';
import { academicCourseListService } from "../../modules/services";
import SideBar from "../commanComponents/sidebar/sidebar";
import FilterDropdown from "../commanComponents/filterDropdown/filterDropdown"; 
import { sidebarNavItems, courseLevelItems, ROUTES, EMPTY_IMAGE } from "../../constant";
import TopNavigation from "../commanComponents/topNavigation/topNavigation";
import AcademicCourseCard from '../commanComponents/academicCourseCard/academicCourseCard';


const AcademicCourses = () => {
    const navigate = useNavigate();
    const [level, setLevel] = useState(courseLevelItems[0]);
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    
    const getCourseListData = useCallback((courseLevel) => { 
        (async () => {
            const responseData = await academicCourseListService({remove_pagination: true, level: courseLevel});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setData(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();
    }, []);

    useEffect(() => {
        getCourseListData("");

        setLevel(courseLevelItems[0]);

    }, [getCourseListData]);

    const handleChangeLevel = (courseLevel) => {
        setLevel(courseLevel);
        getCourseListData(courseLevel.value);
    }
    
    return (
        <div className='academic-courses-container' style={{ display: 'flex' }}>
            <SideBar activeItem={sidebarNavItems.academicCourses} />
            <div className='courses-side-container'>
                <TopNavigation activeItem={sidebarNavItems.academicCourses} />
                
                <div className='row academic-courses-filter-container'>
                    <div className='col academic-courses-filter-col'>
                        
                        <FilterDropdown
                                label="Level"
                                data={level}
                                inputId="level_filter_key"
                                listItems={courseLevelItems}
                                onChangeHandler={handleChangeLevel}
                            />
                    </div>
                    <div className='col academic-courses-filter-col'></div>
                </div>
                
                <div className='academic-courses-main-container'>
                    {
                        isLoading ?
                            <div className='academic-courses-loader-div'>
                                <Spinner animation="border" role="status" className='academic-courses-loader'>
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                            :
                            <Row xs={1} md={2} className="g-4 p-2">
                                {
                                    data.length === 0 ?
                                        <div className='academic-course-empty'>
                                            <img
                                                src={EMPTY_IMAGE}
                                                className='academic-course-empty-img'
                                                alt="coming soon"
                                            />
                                        </div>  
                                    :
                                        data.map((dataRow, index) => {                            
                                            return <AcademicCourseCard key={dataRow.id} {...dataRow} />
                                        })
                                }
                            </Row>
                    }
                </div>
            </div>
        </div>
    );
 }


export default AcademicCourses;
